<div class="dialog">
  <div class="modal-header">
    <img class="modal-close" (click)="dismissModal()" />
    <h4 class="modal-title text-center obfuscated-playback">{{ title }}</h4>
  </div>
  <div class="modal-body obfuscated-playback">
    <div [innerHtml]="message"></div>
    <div *ngIf="extraMessage">{{ extraMessage }}</div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-outline-primary" *ngIf="alternateButton" (click)="altCloseModal()">{{ alternateButton }}</button>
    <button class="btn btn-danger" *ngIf="failButton" (click)="dismissModal()">{{ failButton }}</button>
    <button class="btn btn-success" *ngIf="successButton" (click)="closeModal()">{{ successButton }}</button>
  </div>
</div>
